import { type COLOR, COLORS } from '../types/Colors';

export type ColorClasses = {
    bg: string;
    border: string;
    hover: string;
    text: string;
};

export const getColorClasses = (color: COLOR): ColorClasses => {
    switch (color) {
        case COLORS.GREEN:
            return {
                bg: 'bg-status-green-bg',
                border: 'border-status-green-border',
                hover: 'hover:bg-status-green-hover hover:text-white',
                text: 'text-status-green-text',
            };
        case COLORS.YELLOW:
            return {
                bg: 'bg-status-yellow-bg',
                border: 'border-status-yellow-border',
                hover: 'hover:bg-status-yellow-hover hover:text-white',
                text: 'text-status-yellow-text',
            };
        case COLORS.RED:
            return {
                bg: 'bg-status-red-bg',
                border: 'border-status-red-border',
                hover: 'hover:bg-status-red-hover hover:text-white',
                text: 'text-status-red-text',
            };
        case COLORS.BLUE:
            return {
                bg: 'bg-status-blue-bg',
                border: 'border-status-blue-border',
                hover: 'hover:bg-status-blue-hover hover:text-white',
                text: 'text-status-blue-text',
            };
        case COLORS.GREY:
            return {
                bg: 'bg-surface-light',
                border: 'border-grey-outline-light',
                hover: 'hover:bg-grey-outline-light',
                text: 'text-midnight',
            };
        case COLORS.WHITE:
        default:
            return {
                bg: 'bg-white',
                border: 'border-grey-dark',
                hover: 'hover:bg-grey-outline-light',
                text: 'text-midnight',
            };
    }
};
